import React, { useEffect, useRef } from 'react';

const TradingViewWidget = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!window.TradingView) {
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/tv.js';
      script.async = true;
      script.onload = () => createWidget();
      document.body.appendChild(script);
    } else {
      createWidget();
    }

    function createWidget() {
      if (containerRef.current && window.TradingView) {
        new window.TradingView.widget({
          container_id: 'tradingview_widget',
          autosize: true,
          symbol: 'MEXC:PIUSDT',
          interval: '30',
          timezone: 'Etc/UTC',
          theme: 'dark',
          style: '1',
          locale: 'en',
          enable_publishing: false,
          hide_top_toolbar: false,
          hide_legend: false,
          allow_symbol_change: false,
          withdateranges: true,
          studies: ['MACD@tv-basicstudies'],
          details: true,
          calendar: false,
        });
      }
    }
  }, []);

  return (
    <div
      id="tradingview_widget"
      ref={containerRef}
      style={{ height: '600px', width: '100%' }}
    />
  );
};

export default TradingViewWidget;
